// extracted by mini-css-extract-plugin
export default {"header":"SendRouteModal_header__aqjrX","header__title":"SendRouteModal_header__title__RwsWo","form":"SendRouteModal_form__fHIUc","actions":"SendRouteModal_actions__6Q7Zy"};